import React from "react";
import "../../styles/FormCard.css";

const FormCard = ({ title, subtitle, children, showBackButton, onBack }) => {
  return (
    <div className="form-card">
      <div className="form-card-header">
        {showBackButton && (
          <button onClick={onBack} className="back-button">
            ← Retour
          </button>
        )}
        <div>
          <h2 className="form-card-title">{title}</h2>
          {subtitle && <p className="form-card-subtitle">{subtitle}</p>}
        </div>
      </div>
      <div className="form-card-content">
        {children}
      </div>
    </div>
  );
};

export default FormCard;
